import mixpanel from 'mixpanel-browser'
import { MIXPANEL_PROJECT_TOKEN } from '../constants'
import store from '../store'
mixpanel.init(MIXPANEL_PROJECT_TOKEN[store.state.platform][process.env.NODE_ENV || 'production'])

const Mixpanel = {
    install (Vue) {
        Vue.prototype.$sendMixpanelEvent = (event, properties) => {
            mixpanel.track(event, properties)
            console.log({
                event,
                properties
            })
        }

        Vue.prototype.$setUpMixpanelUser = (email, name, authType, subscription) => {
            mixpanel.alias(email)

            let profileProperties = {
                // only reserved properties need the $
                "$email": email,    
                "$name": name,
                // Send dates in ISO timestamp format (e.g. "2020-01-02T21:07:03Z")
                "$created": new Date().toISOString(), 
                "Sent Messages": 0,
                "Auth Type": authType,
            }
            
            
            if(store.state.platform === 'kickstarter') {
                profileProperties = {
                    ...profileProperties,
                    "Signup Type": subscription ? 'subscription' : 'trial',
                    "Sent Requests": 0,
                    "Cancelled Requests": 0,
                    "Declined Requests": 0,
                    "Accepted Requests": 0,
                    "Expired Requests": 0
                }
            }

            mixpanel.people.set(profileProperties);
            console.log('Mixpanel Profile Created');
        }

        Vue.prototype.$identifyMixpanelUser = email => {
            mixpanel.identify(email)
            console.log('Mixpanel User Identified')
        }

        Vue.prototype.$resetMixpanel = () => {
            mixpanel.reset()
        }

        Vue.prototype.$incrementMixpanelPeopleProperty = property => {
            console.log(`Mixpanel: ${property} + 1`)
            mixpanel.people.increment(property)
        }

        Vue.prototype.$getMixpanelUserId = () => {
            return mixpanel.cookie.props.$user_id
        }
    }
}

export default Mixpanel